import React from 'react';
import Footer from './Footer';
import './Layout.css';

const Layout = ({ children }) => {
  return (
    <div className="app-layout">
      <div className="app-content">
        {children}
      </div>
      <Footer />
    </div>
  );
};

export default Layout;